import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getLabTestsDetails, clearLabTestDetails } from '../../../../redux/Slices/authSlice';


// lab tests details
const LabTestsDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { labTestDetails, isLoading } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getLabTestsDetails(id));
    return () => dispatch(clearLabTestDetails());
  }, [dispatch, id]);

  return (
    <div style={{ padding: '30px', backgroundColor: '#14263b', marginTop: '30px', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ width: '100%', maxWidth: '700px', backgroundColor: '#1b3350', borderRadius: '12px', padding: '24px', border: '1px solid #333' }}>
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 style={{ margin: 0, fontSize: '22px' }}>تفاصيل الاختبار </h1>
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              backgroundColor: 'transparent',
              color: '#fff',
              border: '1px solid #444',
              borderRadius: '6px',
              padding: '8px 16px',
              cursor: 'pointer',
            }}
          >
            رجوع
          </button>
        </div>

        {(!labTestDetails && isLoading) ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#ccc' }}>جاري تحميل البيانات...</div>
        ) : !labTestDetails ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#ccc' }}>لا توجد بيانات لعرضها</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <DetailRow label="الاسم بالعربية" value={labTestDetails.name_ar || '—'} />
            <DetailRow label="الاسم بالإنجليزية" value={labTestDetails.name_en || '—'} />
            <DetailRow label="الحالة" value={labTestDetails.is_active ? 'نشط' : 'موقوف'} highlight={labTestDetails.is_active ? '#27ae60' : '#c0392b'} />
          </div>
        )}
      </div>
    </div>
  );
};

const DetailRow = ({ label, value, highlight }) => (
  <div style={{ backgroundColor: '#1a1f2e', borderRadius: '8px', padding: '16px', border: '1px solid #333' }}>
    <div style={{ color: '#ccc', marginBottom: '6px', fontSize: '13px' }}>{label}</div>
    <div style={{ fontSize: '16px', fontWeight: 'bold', color: highlight || '#fff' }}>{value}</div>
  </div>
);

export default LabTestsDetails;

